import { render, staticRenderFns } from "./PizzaFilters.vue?vue&type=template&id=030874c3&"
import script from "./PizzaFilters.vue?vue&type=script&lang=js&"
export * from "./PizzaFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports